"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextReplacementUtility = void 0;
class TextReplacementUtility {
    constructor(configData, localeService) {
        this.configData = {};
        this.getFinanceFootnote = () => {
            var _a;
            if ((_a = this.configData) === null || _a === void 0 ? void 0 : _a.configuration) {
                const financeParameters = this.configData.configuration.financeParameters
                    ? `${this.configData.configuration.financeParameters} `
                    : '';
                const financeSummaryDisclaimer = this.configData.configuration.financeSummaryDisclaimer
                    ? `${this.configData.configuration.financeSummaryDisclaimer} `
                    : '';
                const financeProductDisclaimer = this.configData.configuration.financeProductDisclaimer
                    ? `${this.configData.configuration.financeProductDisclaimer}`
                    : '';
                return `${financeParameters}${financeSummaryDisclaimer}${financeProductDisclaimer}`;
            }
            return '';
        };
        this.concatStringAndValue = (text, value, seperator) => {
            return value ? `${text}: ${value}${seperator} ` : '';
        };
        this.getEecDisclaimerFootnote = (hasEecScope, eecLabel) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
            const isGermanMarket = ((_a = this.localeService) === null || _a === void 0 ? void 0 : _a.language) === 'de' && ((_b = this.localeService) === null || _b === void 0 ? void 0 : _b.countryCode) === 'DE';
            const eecData = (_d = (_c = this.configData) === null || _c === void 0 ? void 0 : _c.configuration) === null || _d === void 0 ? void 0 : _d.FootnoteEfficiencyModel;
            const techData = (_f = (_e = this.configData) === null || _e === void 0 ? void 0 : _e.configuration) === null || _f === void 0 ? void 0 : _f.techdata;
            const engineType = (_j = (_h = (_g = this.configData) === null || _g === void 0 ? void 0 : _g.configuration) === null || _h === void 0 ? void 0 : _h['wltp-status']) === null || _j === void 0 ? void 0 : _j.engineType;
            const engineTypeName = typeof engineType === 'string' ? engineType : engineType === null || engineType === void 0 ? void 0 : engineType.name;
            const efficiency = (_m = (_l = (_k = this.configData) === null || _k === void 0 ? void 0 : _k.configuration) === null || _l === void 0 ? void 0 : _l.eec) === null || _m === void 0 ? void 0 : _m.efficiency;
            const sustaining = (_q = (_p = (_o = this.configData) === null || _o === void 0 ? void 0 : _o.configuration) === null || _p === void 0 ? void 0 : _p.eec) === null || _q === void 0 ? void 0 : _q['efficiency-sustaining'];
            const isPluginHybrid = engineTypeName === "OVC_HEV";
            const formattedCo2Class = `CO<sub>2</sub>-Klasse: ${efficiency}`;
            if (isPluginHybrid && techData && isGermanMarket) {
                const consumptionWeightedCombined = this.concatStringAndValue('Kraftstoffverbrauch (gewichtet kombiniert)', techData['wltp-consumption-weighted-combined'], ';');
                const electricConsumptionWeightedCombined = this.concatStringAndValue('Stromverbrauch (gewichtet kombiniert)', techData['wltp-electric-consumption-weighted-combined'], ';');
                const co2WeightedCombined = this.concatStringAndValue('CO<sub>2</sub>-Emissionen (gewichtet kombiniert)', techData['wltp-co2-weighted-combined'], ';');
                const co2ClassCombined = this.concatStringAndValue('CO<sub>2</sub>-Klasse (gewichtet kombiniert)', techData['efficiency-class'], ';');
                const consumptionSustainingCombined = this.concatStringAndValue('Kraftstoffverbrauch bei entladener Batterie (kombiniert)', techData['wltp-consumption-sustaining-combined'], ';');
                const co2ClassBatteryDischarged = this.concatStringAndValue('CO<sub>2</sub>-Klasse bei entladener Batterie', sustaining, '.');
                return (consumptionWeightedCombined +
                    electricConsumptionWeightedCombined +
                    co2WeightedCombined +
                    co2ClassCombined +
                    consumptionSustainingCombined +
                    co2ClassBatteryDischarged);
            }
            if (!isPluginHybrid && eecData) {
                const techDataOutput = eecData.Values && eecData.Values.map
                    ? `${eecData.Values.map((techdata) => techdata && techdata.Label && techdata.Value
                        ? `${techdata.Label}: ${techdata.Value};`
                        : '').join(' ')} `
                    : '';
                if (hasEecScope !== undefined && eecLabel !== undefined) {
                    let eecOutput = hasEecScope && eecLabel && eecData.EfficiencyClass
                        ? `${eecLabel}: ${eecData.EfficiencyClass} `
                        : '';
                    eecOutput = isGermanMarket ? '' : eecOutput;
                    const disclaimer = eecData.Disclaimer
                        ? `${formattedCo2Class && isGermanMarket ? '' : eecData.Disclaimer}`
                        : '';
                    return `${techDataOutput}${eecOutput}${isGermanMarket ? formattedCo2Class : ''}${disclaimer}`;
                }
                return `${techDataOutput}${isGermanMarket ? formattedCo2Class : ''}`;
            }
            return '';
        };
        this.configData = configData;
        this.localeService = localeService;
    }
}
exports.TextReplacementUtility = TextReplacementUtility;
//# sourceMappingURL=TextReplacmentUtility.js.map